import React, { useState } from "react";
import AdminLogin from "./Components/AdminLogin";
import AdminDashboard from "./AdminDashboard";

const AdminPage = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  return (
    <div>
      {isLoggedIn ? <AdminDashboard /> : <AdminLogin onLogin={setIsLoggedIn} />}
    </div>
  );
};

export default AdminPage;
